export const leadCampaignObject = {
  subscriptionID: "",
  leadSubscriptionName: "",
  selectedFields: [],
  freezed: false,
};

export function objectFromFormData(formData) {
  return {
    brand_id: formData.brandID,
    lead_subscription_name: formData.leadSubscriptionName,
    selectedFields: formData.selectedFields,
  };
}

export function objectFromResponse(response) {
  return {
    id: response.id,
    subscriptionID: response.config_name,
    leadSubscriptionName: response.config_name,
    selectedFields: response.selectedFields,
    price: response.price,
    freezed: response.is_frozen,
    status: response.active,
    apiDetails: response.api_details
      ? {
          apiKey: response.api_details?.api_key,
          method: response.api_details?.method,
          apiUrl: response.api_details?.api_url,
          configName: response.api_details?.config_name,
          apiCurl: response.api_details?.api_curl,
        }
      : null,
  };
}
